<template>
  <div class="text-white">
    <h2> Welcome To </h2>
    <h1> MIT Automotive </h1>
    <div class="spacer" />
    <Slideshow :images="finalArray" :aspectRatio="'40%'" :isBG="true"/>
  </div>
</template>
<script>
import Slideshow from '@/components/Slideshow'
import Images from '@/assets/json/slideshow-data.json'
export default {
  name: 'home',
  components: {
    Slideshow
  },
  data () {
    return {
      finalArray: Images.images
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Home.vue